import React, {useState, useEffect} from 'react';
import {templatePropTypes} from "../constants"
import Logo from "./Logo"
import MainImage from "./MainImage"
import NewsText from "./NewsText"
import {BottomAd} from "../components/adfoxBlocks/BottomAd"
import {AdfoxBlock} from "../components/adfoxBlocks/AdfoxBlock"
import Sidebar from "./Sidebar"
import SmiWidget from "../components/smiWidgets/SmiWidget"
import SmiJs from "./SmiJs"
import BlurReload from "../utils/blurReload"
import BackClick from "../components/smiWidgets/BackClick";
import Popup from "../components/smiWidgets/Popup";
import WebPushScript from '../services/WebPushScript'
import {loadHeadScripts} from '../services/loadHeadScripts'
import {adfoxOptions} from "./adfox/adfoxOptions"
import {widgetIds} from "./smiWidgets/widgetIds"


export default function Template2001Component({news, context}) {

    const isFull = context.isFull
    const isDesktop = context.device === "desktop"
    const showPopUp = context.pop_up !== undefined ? context.pop_up : true
    const showBackClick = context.back_click !== undefined ? context.back_click : true
    const showSubscriptions = context.collect_subscriptions !== undefined ? context.collect_subscriptions : true
    const subscriptionType = context.subscription_format !== undefined ? context.subscription_format : ''
    const refreshTime = context.refresh_time || 30
    const currentDomain = window.location.hostname;
    const popUpType = context.popup_type || "replace"

    const url = new URL(window.location.href);
    let fprVersion;
    const fprParam = url.searchParams.get('fpr') || context.fpr;
    if (fprParam) {
        fprVersion = fprParam.split('_')[1] || context.fprVersion;
    }

    const adBlocks = adfoxOptions[fprVersion] || adfoxOptions['main']
    const widgetBlocks = widgetIds[fprVersion] || widgetIds['main']

    let sid = context.analytics_lable;

    useEffect(() => {
        loadHeadScripts([
            'https://yandex.ru/ads/system/header-bidding.js',
            'https://yandex.ru/ads/system/context.js',
        ]);
    }, []);

    return (
        <div id="wrapper">
            {showSubscriptions && <WebPushScript activeWidget={subscriptionType}/>}
            {showBackClick && <BackClick adId={widgetBlocks.backClick}/>}
            {showPopUp && <Popup popUpType={popUpType} adId={widgetBlocks.popup}/>}
            <BlurReload url={`https://${currentDomain}/pages/${widgetBlocks.refresh}/?subid=${sid}`} timeout={`${refreshTime}000`}/>
            <SmiJs context={context}/>
            <SmiWidget blockIds={widgetBlocks.push} isFull={isFull} isDesktop={isDesktop}/>
            <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.fullscreen}/>
            <img src="https://data.24smi.net/ctp?id=1" width="1" height="1"/>
            <div className="wrapper-holder">
                <header id="header" className="flex">
                    <strong className="logo">
                        <a href="#">
                            <Logo/>
                        </a>
                    </strong>
                </header>
                <main id="main">
                    <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.topad}/>
                    <div className="main-holder flex">
                        <section id="content">
                            <div className="post-picture">
                                <div className="news-title-200">{news.title}</div>
                                <MainImage news={news}/>
                                <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.ir1}/>
                            </div>
                            <NewsText
                                news={news}
                                isFull={isFull}
                                isDesktop={isDesktop}
                                options={adBlocks}
                            />
                            <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.aa1}/>
                            <SmiWidget blockIds={widgetBlocks.aa2} isFull={isFull} isDesktop={isDesktop}/>
                            <div className="container-post look-also" id="look-also">
                                <h3>Смотрите также</h3>
                                <div className="box">
                                    <SmiWidget blockIds={widgetBlocks.lookAlso} isFull={isFull} isDesktop={isDesktop}/>
                                </div>
                            </div>
                            {!fprVersion &&
                                <SmiWidget blockIds={widgetBlocks.feed} isFull={isFull} isDesktop={isDesktop}/>}
                        </section>
                        <Sidebar isSticky={widgetBlocks.sideBar.isSticky}>
                            <SmiWidget blockIds={widgetBlocks.sideBar} isFull={isFull} isDesktop={isDesktop}/>
                        </Sidebar>
                    </div>
                    {fprVersion &&
                        <SmiWidget blockIds={widgetBlocks.feed} isFull={isFull} isDesktop={isDesktop}/>}
                    <footer className="down"/>
                </main>
            </div>
            <BottomAd isFull={isFull} isDesktop={isDesktop} options={adBlocks.floorad}/>
            <SmiWidget blockIds={widgetBlocks.empty} isFull={isFull} isDesktop={isDesktop}/>
        </div>
    );
}
